import { getShellApiInstance } from '../../common/shell-api-helpers'

export const getShellVersion = () => getShellApiInstance().meta.shellVersion
